var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: {
        [_vm.$style.expired]: !!_vm.directory.explorationStartDate,
        [_vm.$style.optinDialog]: true,
      },
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c(
            "i",
            { staticClass: "material-icons", class: _vm.$style.warning },
            [_vm._v("error_outline")]
          ),
          !_vm.directory.explorationStartDate
            ? _c("div", { class: _vm.$style.texts }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.user.firstName) + ", welcome to your"),
                ]),
                _c("div", { class: _vm.$style.subHeader }, [
                  _vm._v("Hotel Directory"),
                ]),
              ])
            : _c("div", { class: _vm.$style.texts }, [
                _c("div", [
                  _vm._v(_vm._s(_vm.user.firstName) + ", your Hotel Directory"),
                ]),
                _c("div", { class: _vm.$style.subHeader }, [
                  _vm._v(" Trial has Expired "),
                ]),
              ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          !_vm.directory.explorationStartDate
            ? [
                _c("p", { class: _vm.$style.p }, [
                  _vm._v(" Hi "),
                  _c("b", [_vm._v(_vm._s(_vm.user.firstName) + ",")]),
                ]),
                _c("p", { class: _vm.$style.p }, [
                  _vm._v(" Welcome to the "),
                  _c("b", [_vm._v(_vm._s(_vm.account.name))]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.year) +
                      " Global Hotel Directory. The hotels within are a compilation of your hard earned negotiated and finalized hotel agreements. "
                  ),
                ]),
                _c("p", { class: _vm.$style.p }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.user.firstName) +
                      ", You are welcome to peruse the directory for "
                  ),
                  _c("b", [_vm._v("5 business Days")]),
                  _vm._v(
                    ". After 5 days, if you would like to take advantage of all the directory has to offer, you will need to agree to activate and pay "
                  ),
                  _c("b", [_vm._v("$49 per month")]),
                ]),
                _c("p", { class: _vm.$style.p }, [
                  _vm._v(
                    " We really appreciate your patronage " +
                      _vm._s(_vm.user.firstName) +
                      " and hope you will choose to opt in. "
                  ),
                ]),
              ]
            : [
                _c("p", { class: _vm.$style.p }, [
                  _vm._v(
                    " Your hotel directory exploration period has expired. In order to continue using the hotel directory, you will need to opt in for the "
                  ),
                  _c("b", [_vm._v("$49")]),
                  _vm._v(" monthly fee below. "),
                ]),
              ],
          _c("p", { class: _vm.$style.p }, [_vm._v(" ReadyBid Support ")]),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          !_vm.directory.explorationStartDate
            ? [
                _c(
                  "button",
                  {
                    staticClass: "rbButton",
                    class: _vm.$style.left,
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.takeAction("explore")
                      },
                    },
                  },
                  [_vm._v(" I'll Just Look Around ")]
                ),
              ]
            : !_vm.directory.trialExtended
            ? _c(
                "button",
                {
                  staticClass: "rbButton",
                  class: _vm.$style.left,
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.takeAction("extend")
                    },
                  },
                },
                [_vm._v(" Extend Trial by Another 7 days ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButton mainButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.takeAction("optIn")
                },
              },
            },
            [
              _vm._v(" Activate only "),
              _c("b", [_vm._v("$49")]),
              _vm._v("/month "),
            ]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }